import P from "prop-types";
import * as S from "../styles";

import { BarChartCard } from "../../ChartCards/BarChartCard";
import { HorizontalBarChartCard } from "../../ChartCards/HorizontalBarChartCard";
import { SimplePieChartCard } from "../../ChartCards/SimplePieChartCard";
import { HorizontalZoomBarChartCard } from "../../ChartCards/HorizontalZoomBarChartCard";

import { dadosGraficos } from "../../dados";

export function Capitulo4({ currentIndex }) {
  const chartStyle = {
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };

  if (currentIndex !== 4) {
    return <></>;
  } else {
    return (
      <S.Container>
        <S.Container2>
          <S.Grid>
            <HorizontalBarChartCard
              grid
              title="Tipos de problemas com EPIs"
              dados={dadosGraficos.grafico35}
              style={chartStyle}
            />

            <SimplePieChartCard
              grid
              title="Os EPIs recebidos são suficientes"
              dados={dadosGraficos.grafico34}
              style={chartStyle}
            />
          </S.Grid>

          <HorizontalBarChartCard
            title="Considera que o treinamento foi satisfatório"
            dados={dadosGraficos.grafico33}
            style={chartStyle}
          />

          <S.Grid>
            <SimplePieChartCard
              grid
              title="A instituição ofereceu ações em saúde mental"
              dados={dadosGraficos.grafico36}
              style={chartStyle}
            />
            <BarChartCard
              grid
              title="Tipos de ações oferecidas em saúde mental"
              dados={dadosGraficos.grafico37}
              style={chartStyle}
            />
          </S.Grid>

          <HorizontalZoomBarChartCard
            title="O que o trabalho com a covid-19 representa"
            dados={dadosGraficos.grafico38}
            style={chartStyle}
          />
        </S.Container2>
      </S.Container>
    );
  }
}

Capitulo4.propTypes = {
  currentIndex: P.number.isRequired,
};
